import { SKILLS } from '../constants/config';

export default function SkillsSection() {
  return (
    <section className="mb-28">
      <h2 className="text-4xl font-bold mb-4">Professional Skills</h2>
      <p className="text-gray-400 mb-12 text-lg">Expertise in modern web technologies and design patterns</p>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        {SKILLS.map((skill, index) => (
          <div key={index} className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 group">
            <div className="mb-6">
              <h3 className="text-xl font-bold text-white mb-2">{skill.name}</h3>
              <p className="text-3xl font-bold text-transparent bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text">{skill.percentage}%</p>
            </div>
            <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
              <div 
                className={`bg-gradient-to-r ${skill.color} h-full rounded-full`}
                style={{width: `${skill.percentage}%`, animation: `slideIn 1s ease-out ${skill.delay} backwards`}}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
